/*
 * File: UIListItem.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: A component for displaying a list element in a standard layout
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { ListItem, ListItemText, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

const styles = theme => ({
  root: {
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    "&.lastChild:last-child": {
      borderBottom: 0
    }
  },
  primary: {
    fontWeight: "bold"
  },
  listItem: {
    flexWrap: "wrap"
  },
  preserveWhiteSpace: {
    whiteSpace: "pre-wrap"
  }
});

const UIListItem = ({
  classes,
  label,
  value,
  labelGroup,
  divider = true,
  preserveValueWhiteSpace = false
}) => {
  let valueClassName;
  if (preserveValueWhiteSpace) {
    valueClassName = classes.preserveWhiteSpace;
  }
  return (
    <div className={classes.root}>
      <ListItem
        divider={divider}
        className={classes.listItem}
        disableGutters={true}
      >
        {labelGroup && (
          <ListItemText>
            <span className={classes.primary}>{labelGroup.label}</span>
            <Typography classes={{ root: valueClassName }}>
              {labelGroup.value}
            </Typography>
          </ListItemText>
        )}

        {label && (
          <React.Fragment>
            <ListItemText>
              <span className={classes.primary}>{label}</span>
            </ListItemText>
            <Typography classes={{ root: valueClassName }}>{value}</Typography>
          </React.Fragment>
        )}
      </ListItem>
    </div>
  );
};

UIListItem.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  value: PropTypes.node,
  labelGroup: PropTypes.object,
  divider: PropTypes.bool
};

export default withStyles(styles)(UIListItem);
